// $(function() {
//     $('#parallax-mouse-move').mousemove(function (e) {
//         parallax(e, this, 1);
//         // parallax(e, document.getElementById())
//     });
// });
//
// function parallax(e, target, layer) {
//     var layer_coeff = 10 / layer;
//     var x = ($(window).width() - target.offsetWidth) / 2
// }
